export const TypesRemontagemVolume = {
    SET_PROPERTY: "remontagemVolume/SET_PROPERTY",
    SET_MASTER_PROPERTY: "remontagemVolume/SET_MASTER_PROPERTY",
    SET_NOVO_MASTER_PROPERTY: "remontagemVolume/SET_NOVO_MASTER_PROPERTY",
    RESET_INFOS: "remontagemVolume/RESET_INFOS",
    RESET_REMONTAGEM_VOLUME: "remontagemVolume/RESET_REMONTAGEM_VOLUME",
}

export const INITIAL = {
    Tab: '1',
    Master: {
        Etiqueta: '',
        EtiquetaFormatada: '',
        InfosEtiqueta: '',
        QuantidadeRegular: undefined,
        EmbalagemMasterSelecionada: { Id: 0, Codigo: '', Descricao: '' },
        DisableBotaoRemontar: false
    },
    NovoMaster: {
        Etiqueta: '',
        EtiquetaFormatada: '',
        TipoDoc: '0',
        NumeroDoc: '',
        NumeroDocRelacionado: '',
        DescricaoClienteDocRelacionado: '',
        Descricao: '',
        Marca: '',
        EmbalagemMasterSelecionada: { Id: 0, Codigo: '', Descricao: '' },
        QuantidadeRegular: undefined,
        EmbalagemRegularSelecionada: { Id: 0, Codigo: '', Descricao: '', Qtde: 0 }
    },
    EmbalagensMaster: [],
    EmbalagensRegulares: []
}

export default function remontagemVolumeReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesRemontagemVolume.SET_PROPERTY:

            let newObj = {};

            Object.assign(newObj, state);

            newObj[action.payload.campo] = action.payload.valor;

            return newObj;
        case TypesRemontagemVolume.SET_MASTER_PROPERTY:

            let newMasterObj = {};

            Object.assign(newMasterObj, state.Master);

            newMasterObj[action.payload.campo] = action.payload.valor;

            return {
                ...state,
                Master: newMasterObj
            };
        case TypesRemontagemVolume.SET_NOVO_MASTER_PROPERTY:
            let newNovoMasterObj = {};

            Object.assign(newNovoMasterObj, state.NovoMaster);

            newNovoMasterObj[action.payload.campo] = action.payload.valor;

            return {
                ...state,
                NovoMaster: newNovoMasterObj
            };
        case TypesRemontagemVolume.RESET_INFOS:
            return {
                ...state,
                Master: {
                    ...state.Master,
                    InfosEtiqueta: '',
                    QuantidadeRegular: undefined,
                    EmbalagemMasterSelecionada: { Id: 0, Codigo: '', Descricao: '' },
                    DisableBotaoRemontar: false
                },
                NovoMaster: {
                    Etiqueta: '',
                    EtiquetaFormatada: '',
                    TipoDoc: '0',
                    NumeroDoc: '',
                    NumeroDocRelacionado: '',
                    DescricaoClienteDocRelacionado: '',
                    Descricao: '',
                    Marca: '',
                    EmbalagemMasterSelecionada: { Id: 0, Codigo: '', Descricao: '' },
                    QuantidadeRegular: undefined,
                    EmbalagemRegularSelecionada: { Id: 0, Codigo: '', Descricao: '', Qtde: 0 }
                },
            }
        case TypesRemontagemVolume.RESET_REMONTAGEM_VOLUME:
            return INITIAL;
        default:
            return state;
    }
}

export const RemontagemVolumeActions = {
    setProperty,
    setMasterProperty,
    setNovoMasterProperty,
    resetInfos,
    resetRemontagemVolume
}

function setProperty(valor, campo) {
    return {
        type: TypesRemontagemVolume.SET_PROPERTY,
        payload: { valor: valor, campo: campo }
    }
}

function setMasterProperty(valor, campo) {
    return {
        type: TypesRemontagemVolume.SET_MASTER_PROPERTY,
        payload: { valor: valor, campo: campo }
    }
}

function setNovoMasterProperty(valor, campo) {
    return {
        type: TypesRemontagemVolume.SET_NOVO_MASTER_PROPERTY,
        payload: { valor: valor, campo: campo }
    }
}

function resetInfos() {
    return { type: TypesRemontagemVolume.RESET_INFOS }
}

function resetRemontagemVolume() {
    return { type: TypesRemontagemVolume.RESET_REMONTAGEM_VOLUME }
}